// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-3tVy5";
var _4 = "labelContainer-dKXAh";
var _5 = "label-199gs";
var _6 = "checked-2sDWh";
var _7 = "radio-1kyiH";
var _8 = "tooltip-2JFC9";
var _9 = "tooltip_arrow-1sc9r";
var _a = "form-uQVxw";
var _b = "form_error-1AGQ6";
var _c = "price-443iI";
var _d = "singleTravellerInOrder-3CeRg";
var _e = "priceContent-IAnuX";
var _f = "done-3f0jE";
var _10 = "labelMute-31SoO";
var _11 = "label__agreement-8TAnt";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "labelContainer", _5 as "label", _6 as "checked", _7 as "radio", _8 as "tooltip", _9 as "tooltip_arrow", _a as "form", _b as "form_error", _c as "price", _d as "singleTravellerInOrder", _e as "priceContent", _f as "done", _10 as "labelMute", _11 as "label__agreement" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "labelContainer": _4, "label": _5, "checked": _6, "radio": _7, "tooltip": _8, "tooltip_arrow": _9, "form": _a, "form_error": _b, "price": _c, "singleTravellerInOrder": _d, "priceContent": _e, "done": _f, "labelMute": _10, "label__agreement": _11 }
